module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_431008.9331fbf7.png";